// extracted by mini-css-extract-plugin
export var textInput = "_f1-0";